import type { AllIssueItem, PaginatedResponse, TaskFilters } from '@hygge/shared';
import { api } from './api';

/**
 * Cross-board "All issues" pool. Returns tasks from every board the caller can
 * see, each carrying its owning board (`item.board`). Same query surface as the
 * per-board list minus the board scoping (that is resolved server-side).
 */
export async function getAllIssues(
  filters?: TaskFilters & {
    page?: number;
    limit?: number;
    sort?: string;
    order?: string;
    /** Comma-separated board ids; narrows the boards searched, never widens them. */
    boardIds?: string;
  },
): Promise<PaginatedResponse<AllIssueItem>> {
  const { data } = await api.get<PaginatedResponse<AllIssueItem>>('/all-issues', {
    params: filters,
  });
  return data;
}
